import React, { FunctionComponent } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import { Club } from "/src/domain/studentProfile/StudentProfileData";
import { Avatar, Typography } from "@mui/material";
import { theme } from "/src/assets/theme";
import { ClubLogo } from "../shared/ClubLogo";

interface RatingHeaderData {
  club: Club;
}

const RatingHeader: FunctionComponent<RatingHeaderData> = ({ club }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Typography variant="h1" className={classes.header}>
        {t("ratingClub")}
      </Typography>
      <div className={classes.nameContainer}>
        <ClubLogo url={club.logoUrl} className={classes.avatar} />
        <Typography variant="h2" className={classes.name}>
          {club.name}
        </Typography>
      </div>
    </>
  );
};

const useStyles = makeStyles((muiTheme) => ({
  nameContainer: {
    color: muiTheme.palette.primary.contrastText,
    padding: "1rem 4rem 1rem 9rem",
    fontSize: "1.15rem",
    fontWeight: 500,
    background: `url(${require("../../assets/icons/primary_rect.svg")})`,
    backgroundRepeat: "no-repeat",
    display: "inline-block",
    backgroundPositionX: "right",
    backgroundSize: "cover",
    position: "relative",
    marginTop: "3.25rem",
    marginBottom: "3.75rem",
  },
  name: {
    fontSize: "1.25rem",
    color: "white",
    marginLeft: "1rem",
  },
  header: {
    fontSize: "1.5rem",
    marginLeft: "1.5rem",
    marginTop: "1.5rem",
  },
  avatar: {
    position: "absolute",
    left: "1rem",
    transform: "translate(0%,-50%)",
    top: "50%",
  },
}));

export default RatingHeader;
